import PropTypes from 'prop-types';

import Container, { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { ForgotPassword as ForgotPasswordForm } from '@classity-edtech/ui-auth';
import { useNavigate } from 'react-router-dom';
import Helmet from '../../components/Helmet';

export interface ForgotPasswordProps extends MuiContainerProps {}

export const ForgotPassword = ({ className }: ForgotPasswordProps) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(`/${path}`);
  };

  return (
    <>
      <Helmet />
      <ForgotPasswordForm navigate={handleNavigation} />
    </>
  );
};

ForgotPassword.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ForgotPassword.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(ForgotPassword)(
  ({ theme }) => `
`,
);
